<h2 mat-dialog-title>Import Calibration from Previous Study</h2>
<mat-dialog-content class="mat-typography">
    <div>       
        <div class="import-calibration">
            <div>
                <span>Importing overwrites the last saved calibration adjustments with baseline values and will be saved into the database.</span>           
            </div>
            <div>
                <span class="title-font">Importing from Baseline project</span>  
            </div>
            <div>
                <span class="project-name">{{baselineProjectName}}</span>  
            </div>
            <div>
                <span class="title-font">Calibrated Run</span>  
            </div>            
            <mat-select [(value)]="selectedBaselineProjectRunId" class="import-select" panelClass="import-select-panel" placeholder="Select Baseline Run" (selectionChange)="selectBaselineRun()">
                <mat-option *ngFor="let run of data.baseLineRuns" [value]="run.id" >
                    {{run.description}}
                </mat-option>  
            </mat-select>           
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
   <button id="import-calibration-cancel" mat-button mat-dialog-close>CANCEL</button>
   <button id="import-calibration-save" mat-raised-button color="primary" cdkFocusInitial [disabled]= "disableImport()" (click)="saveBaselineRun()">IMPORT</button>
</mat-dialog-actions>
